import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import logo from "../../assets/kazhavda-logo.png";
import {
  Grid,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import "./Login.css";

const API = process.env.REACT_APP_API_BASE;

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const fromSignup = location.state?.fromSignup;
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await fetch(
        `${API}/login?email=${email}&password=${password}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Invalid credentials");
      }

      const data = await response.json();
      const {
        id_token,
        refresh_token,
        email: user_email,
        firebase_uid,
        role,
      } = data;

      login({ id_token, refresh_token, user_email, firebase_uid, role });

      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Грешка при најавување. Обиди се повторно.");
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid
        item
        size={{ xs: 10, md: 8, lg: 6, xl: 4 }}
        className="form-container"
      >
        <form onSubmit={handleLogin}>
          <Grid container direction="column" spacing={2}>
            <Grid item className="form-container-logo">
              <img src={logo} alt="Kazhav Da Logo" className="form-logo" />
            </Grid>
            <Grid item>
              <Typography variant="h5" className="form-title">
                Постоечки профил (стара форма)
              </Typography>
            </Grid>
            {fromSignup && (
              <Grid item>
                <Typography variant="body2" color="primary">
                  Испратен е е-мејл за верификација. Откако ќе го потврдите,
                  најавете се со вашите податоци.
                </Typography>
              </Grid>
            )}
            <Grid item>
              <TextField
                label="Е-мејл адреса"
                variant="outlined"
                fullWidth
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-text-field"
                required
              />
            </Grid>
            <Grid item>
              <TextField
                label="Лозинка"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-text-field"
                required
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={<Checkbox className="custom-checkbox" />}
                label="Запомни ме"
              />
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                className="button-login"
                fullWidth
              >
                Најавете се
              </Button>
            </Grid>
            {error && (
              <Grid item>
                <Typography variant="body2" color="error">
                  {error}
                </Typography>
              </Grid>
            )}
            <Grid item>
              <Typography variant="body2" className="form-container-link">
                <Link to="/sign-up" className="custom-link">
                  Регистрирајте се
                </Link>
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" className="form-container-link">
                <Link to="/forgot-password" className="custom-link">
                  Заборавивте лозинка?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
}
